/**
 * DatePicker2 helpers — fit input width and nudge jQuery UI popup below the field box.
 * Styles: stylesheets-src/_DatePicker2.scss
 */

function tsDp2MeasureInputTextWidth(el, text) {
  var style = window.getComputedStyle(el);
  var mirror = document.createElement("span");
  mirror.setAttribute("aria-hidden", "true");
  mirror.style.position = "absolute";
  mirror.style.left = "-9999px";
  mirror.style.visibility = "hidden";
  mirror.style.whiteSpace = "pre";
  mirror.style.fontFamily = style.fontFamily;
  mirror.style.fontSize = style.fontSize;
  mirror.style.fontWeight = style.fontWeight;
  mirror.style.fontStyle = style.fontStyle;
  mirror.style.letterSpacing = style.letterSpacing;
  mirror.style.textTransform = style.textTransform;
  mirror.textContent = text;
  document.body.appendChild(mirror);
  var width = mirror.getBoundingClientRect().width;
  document.body.removeChild(mirror);
  return Math.ceil(width);
}

function tsDp2FitInputWidth(inputId) {
  var el = document.getElementById(inputId);
  if (!el) {
    return;
  }
  var apply = function () {
    if (!el.value) {
      el.style.setProperty("width", "0", "important");
      return;
    }
    el.style.setProperty("width", tsDp2MeasureInputTextWidth(el, el.value) + "px", "important");
  };
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(apply).catch(apply);
  } else {
    apply();
  }
}

function tsDp2NudgeDatepickerPopup(inst, inp) {
  if (!inp || !$(inp).is("[data-ts-dp2-input]")) {
    return;
  }
  setTimeout(function () {
    var $dp = inst.dpDiv;
    var $inp = $(inp);
    var $field = $inp.closest(".ts-dp2-field");
    if (!$dp.length || !$field.length) {
      return;
    }
    var gap = 3;
    var fieldOffset = $field.offset();
    var isFixed = $dp.css("position") === "fixed";
    var scrollLeft = $(window).scrollLeft();
    var scrollTop = $(window).scrollTop();
    var targetLeft = fieldOffset.left - (isFixed ? scrollLeft : 0);

    $dp.css("left", targetLeft + "px");

    if ($dp.hasClass("above")) {
      return;
    }

    var targetTop = fieldOffset.top + $field.outerHeight() + gap;
    var dpTop = $dp.offset().top;
    if (dpTop < targetTop) {
      $dp.css("top", targetTop - (isFixed ? scrollTop : 0) + "px");
    }
  }, 0);
}

window.tsDp2FitInputWidth = window.tsDp2FitInputWidth || tsDp2FitInputWidth;
window.tsDp2NudgeDatepickerPopup = window.tsDp2NudgeDatepickerPopup || tsDp2NudgeDatepickerPopup;

if (!window.tsDp2FitInputWidthBound) {
  window.tsDp2FitInputWidthBound = true;
  $(document).on("mouseup", ".ts-dp2-shell a.dateBackward, .ts-dp2-shell a.dateForward", function () {
    var id = $(this).closest("table.datePickerTable").attr("data-id");
    if (id && typeof window.tsDp2FitInputWidth === "function") {
      setTimeout(function () {
        window.tsDp2FitInputWidth(id);
      }, 0);
    }
  });
}
